import { CropConnectRoleDefinitions } from '../../../../services/cropConnectApiClient';

//roles able to access the widget
export const widgetRoles = [
  CropConnectRoleDefinitions.Grower_DE,
  CropConnectRoleDefinitions.Grower_Organic_DE,
];
